import { ShippingRateLima } from "../Model/ShippingRateLima";
import { ShippingRepository } from "../Repository/ShippingRepository";

export interface GetShippingRatesLimaUseCase {
    invoke: () => Promise<ShippingRateLima[]>;
}

export class GetShippingRatesLima implements GetShippingRatesLimaUseCase {
    private shippingRepo: ShippingRepository;

    constructor(_shippingRepo: ShippingRepository) {
        this.shippingRepo = _shippingRepo;
    }

    invoke(): Promise<ShippingRateLima[]> {
        return this.shippingRepo.getShippingRatesLima();
    }
}